import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Button, Navbar, Nav, Card, Modal } from "react-bootstrap";
import { FaStar, FaHeart, FaGlobe, FaRegHandPaper, FaComments, FaGlasses, FaHourglassHalf, FaBookOpen, FaBook, FaTimes, FaClock, FaCompass, FaHospitalSymbol, FaHospitalAlt, FaRegHospital, FaHospitalUser, FaHeartbeat, FaChild, FaGlobeAfrica, FaStarHalfAlt } from "react-icons/fa";
import { signInWithGoogle, auth, provider, signInWithPopup, onAuthStateChanged } from "./firebase";
import { getFirestore, doc, setDoc, getDoc, collection,query, where, getDocs, addDoc, serverTimestamp, onSnapshot, orderBy, updateDoc} from "firebase/firestore";
import { getAuth, getRedirectResult, setPersistence, browserSessionPersistence, signInWithRedirect, GoogleAuthProvider } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import PriestRegistrationModal from "./PriestRegistrationModal";
import { FaBookBookmark, FaBookOpenReader, FaHeartPulse, FaHourglass, FaRegStar } from "react-icons/fa6";
// import { Button } from "@/components/ui";
import mixpanel from 'mixpanel-browser';

mixpanel.init("86de7d139ee44bfa8c2a1082d8656ab6", {track_pageview: true 
});


const LandingPage = () => {
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [isSignedIn, setIsSignedIn] = useState(false);
    const [userPhoto, setUserPhoto] = useState('');
    const [userName, setUserName] = useState('');
    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
      mixpanel.track('open priest reg. modal', {
    })
      setIsModalOpen(true);
    }
    const closeModal = () => {
       mixpanel.track('close priest reg. modal', {
    })
      setIsModalOpen(false);
    }

    // ratings modal
    const [showReviewModal, setShowReviewModal] = useState(false);
    const [reviewConsultant, setReviewConsultant] = useState(null);
    const [rating, setRating] = useState(0);
    const [reviewCount, setReviewCount] = useState(0);

  
    const handleOpenReviewModal = async () => {
       mixpanel.track('open review homepage', {
    })
      const db = getFirestore();
      const priestReviewRef = doc(db, "publicReview", "priests");
    
      const snapshot = await getDoc(priestReviewRef);
    
      if (snapshot.exists()) {
        const data = snapshot.data();
        const reviews = data.review || [];
        const ratings = data.rating || [];
    
        setReviewConsultant({
          review: reviews,
          ratingArray: ratings
        });
      }
    
      setShowReviewModal(true);
    };
    


    // useEffect(() => {
    //   const auth = getAuth();
    
    //   const fetchUser = async () => {
    //     // Retrieve user after redirect
    //     const result = await getRedirectResult(auth);
    
    //     if (result?.user) {
    //       console.log("Redirect result:", result);
    //       const googleUser = result.user;
    //       setUser(googleUser);
    //       setIsSignedIn(true);
    //       setUserPhoto(googleUser.photoURL);
    //       setUserName(googleUser.displayName);
    //     }
    //   };
    
    //   // Auth state listener (runs every time auth state changes)
    //   const unsubscribe = onAuthStateChanged(auth, async (user) => {
    //     console.log("Auth state changed:", user);
    
    //     if (user) {
    //       setUser(user);
    //       setIsSignedIn(true);
    //       setUserPhoto(user.photoURL);
    //       setUserName(user.displayName);
    
    //       const db = getFirestore();
    //       const userRef = doc(db, "priest_users", user.uid);
    //       let userSnap = await getDoc(userRef);
    
    //       if (!userSnap.exists()) {
    //         await setDoc(userRef, {
    //           uid: user.uid,
    //           name: user.displayName,
    //           email: user.email,
    //           role: "user",
    //           credit: 0,
    //           photoURL: user.photoURL,
    //         });
    //       }
    
    //       if (userSnap.exists() && userSnap.data().role === "consultant") {
    //         navigate("/dashboard");
    //       }
    //     } else {
    //       console.log("User is signed out.");
    //       setIsSignedIn(false);
    //     }
    //   });
    
    //   // Run fetchUser only once after a redirect
    //   fetchUser();
    
    //   return () => unsubscribe(); // Cleanup auth listener on unmount
    // }, []);
    
    


    // const handleGoogleSignup = async () => {
    //     const auth = getAuth();
    //     const provider = new GoogleAuthProvider();
    
    //     try {
    //         await setPersistence(auth, browserSessionPersistence); // Ensures session persists
    //         await signInWithRedirect(auth, provider);
    //     } catch (error) {
    //         console.error("Error during sign-in:", error.message);
    //     }
    // };
    
  
    useEffect(() => {
      const fetchRatingData = async () => {
        const db = getFirestore();
        const priestReviewRef = doc(db, "publicReview", "priests");
    
        const snapshot = await getDoc(priestReviewRef);
    
        if (snapshot.exists()) {
          const data = snapshot.data();
          const ratings = data.rating || [];
          const totalRating = ratings.reduce((sum, r) => sum + r, 0);
          const avgRating = ratings.length > 0 ? totalRating / ratings.length : 0;
    
          setRating(avgRating);
          setReviewCount(ratings.length);
        }
      };
    
      fetchRatingData();
    }, []);
    


    const handleGoogleSignup = async () => {
      mixpanel.track('signing in', {
    })
      const auth = getAuth();
      const provider = new GoogleAuthProvider();
        const googleUser = await signInWithGoogle(auth, provider);
        if (googleUser) {
          setUser(googleUser);
          // console.log("googleUser: ", googleUser)
    
        const db = getFirestore();
    
        const userRef = doc(db, "priest_users", googleUser.uid);
        let userSnap = await getDoc(userRef);
        setIsSignedIn(true);
        setUserPhoto(googleUser.photoURL)
        setUserName(googleUser.displayName);
    
        if (!userSnap.exists()) {
          // If user does not exist in Firestore, create a new record
            await setDoc(userRef, {
                uid: googleUser.uid,
                name: googleUser.displayName,
                email: googleUser.email,
                role: "user",
                credits: 0, // Default earnings
                // ratePerMinute: 2, // Default rate,
                photoURL:googleUser.photoURL,
                email:googleUser.email
            });
    
            // Re-fetch user data to get the latest role
            // userSnap = await getDoc(userRef);

            // display welcome message to new users

    
        }
    
        // Redirect if user is a consultant
        if (userSnap.exists() && userSnap.data().role === "consultant") {
            // navigate to "/consultant-dashboard"
            navigate("/dashboard"); // Navigate using the passed function
            // window.location.href = "/dashboard";
            // console.log("role: ", userSnap.data().role)
        }
    
    
        }
        
      };

  const renderStars = (rating) => {
      const stars = [];
      const rounded = Math.round(rating * 2) / 2; // Round to nearest 0.5
    
      for (let i = 1; i <= 5; i++) {
        if (i <= rounded) {
          stars.push(<FaStar key={i} color="#ffc107" />);
        } else if (i - 0.5 === rounded) {
          stars.push(<FaStarHalfAlt key={i} color="#ffc107" />);
        } else {
          stars.push(<FaRegStar key={i} color="#e4e5e9" />);
        }
      }
    
      return stars;
    };


  return (
    <>
      {/* Navigation Bar */}
      <Navbar expand="lg" bg="white" className="shadow-sm">
        <Container>
          <Navbar.Brand style={{color:"#5C4033"}} href="https://www.priests.africa" className="fw-bold fs-4">
           <img src="./logo.png" width="110" alt="logo" /> 
          </Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="ms-auto">
              {/* <Nav.Link href="#how-it-works">How It Works</Nav.Link>
              <Nav.Link href="#about">About</Nav.Link>
              <Nav.Link href="#contact">Contact</Nav.Link> */}
              <Button  variant="outline-dark" style={{  width:'100%', height:50}} onClick={handleGoogleSignup} className="me-2"> Start chatting? 💬 </Button>
              {/* <Button variant="primary">Create Your Account</Button> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>

      {/* Hero Section */}
      <div className="hero-section text-center text-white">
        <Container>
          <Row className="align-items-center">
            <Col md={6}>
              {/* <h1 className="fw-bold">A Clear Path Awaits You.</h1> */}
              <h1 className="fw-bold">Unsure of Your Next Path?</h1>
              {/* <h1 className="fw-bold">Unsure of Life's Decisions?</h1> */}
              <p className="lead">
                24/7 chat with trusted & verified African priests.
              </p>
            <Button style={{ margin: 5, minWidth: 200 }} onClick={handleGoogleSignup} variant="success" size="lg">
                Start chatting? 💬
            </Button>
            <Button onClick={openModal} style={{ margin: 5, minWidth: 200 }} variant="success" size="lg">
                Join as a Priest?
            </Button>
            

              <div className="mt-3">
                <div
                  className="d-flex align-items-center justify-content-center text-warning mt-3"
                  style={{ fontSize: 16, cursor: "pointer" }}
                  onClick={() => handleOpenReviewModal(null)}
                >
                  {renderStars(rating || 0)}
                  <span className="ms-2 text-white">{reviewCount || 0} Reviews</span>
                </div>
              </div>
            </Col>
            <Col md={6}>
              <img
                // src="https://asanee44.com/wp-content/uploads/2024/07/Fasting-in-African-Spirituality-Traditions-and-Practices.jpg"
                src="https://static.wixstatic.com/media/a6e1f8_2a0a5ac828814c33aa7ac7a7cf1f1701~mv2.jpg/v1/fill/w_667,h_1000,al_c,q_85,usm_0.66_1.00_0.01/a6e1f8_2a0a5ac828814c33aa7ac7a7cf1f1701~mv2.jpg"
                alt="Spiritual Guidance"
                className="img-fluid rounded hero-image"
              />
            </Col>
          </Row>
        </Container>
      </div>

      <Container className="text-center my-5">
          <Row>
              <Col md={8} className="mx-auto">
                  <h2 style={{ color: "#094800" }}>About Us</h2>
                  <p className="text-muted">
                    Our priests offer clarity, direction and solutions to life's important decisions. 
                                      </p>
                  <p className="text-muted">                    
                    Priests.Africa connects Africans to verified, ethical African Priests in <b>a simple chat experience.</b>
                  </p>
                  <p className="text-muted">
                      All our Priests go through 5 stages of spiritual, ethical and intellectual vetting. Our verified priests are available 24/7 to support you on your life's journey.
                  </p>
              </Col>
          </Row>
      </Container>

      <Container className="text-center my-5">
        <h2 style={{ color: "#094800" }}>Explore by Topic</h2>
        <Row className="justify-content-center mt-4">
            {[
            { title: "Love, Marriage & Relationship", icon: <FaHeart />, color: "#F8D7DA" },
            { title: "Career & Financial Readings", icon: <FaCompass />, color: "#D4EDDA" },
            { title: "Business & Start-up Consultancy", icon: <FaGlobe />, color: "#FFF3CD" },
            { title: "Health & Wellness", icon: <FaHeartPulse />, color: "#D6EAF8" },
            { title: "Future & Past Insights", icon: <FaClock />, color: "#ffcdef" },
            { title: "General Life Readings", icon: <FaRegHandPaper />, color: "#cdd6ff" },
            { title: "My Spirituality", icon: <FaGlobeAfrica />, color: "#cdffe5" },
            { title: "Children & Parenting", icon: <FaChild />, color: "#ffddcd" },

            ].map((category, index) => (
            <Col key={index} md={2} sm={6} className="mb-3">
                <Card onClick={handleGoogleSignup} 
                className="text-center shadow-sm d-flex flex-column align-items-center justify-content-center"
                style={{ backgroundColor: category.color, height: "200px" }} // Ensures uniform size
                >
                <div style={{ fontSize: "32px" }}>{category.icon}</div>
                <Card.Text className="fw-bold m-1">{category.title}</Card.Text>
                </Card>
            </Col>
            ))}
        </Row>
        </Container>


      {/* About Section */}
      <Container className="text-center my-5">
        <Row>
          <Col md={8} className="mx-auto">
            <h2 style={{color:"#094800"}}>Discover Priests.Africa</h2>
            <p className="text-muted">
              Move beyond uncertainties and find your clear path with verified priests. Available 24/7.
            </p>
            <div className="d-flex justify-content-center align-items-center">
              {/* <img src="https://source.unsplash.com/50x50/?people" className="rounded-circle me-2" alt="User" />
              <span>Over 54,512 people helped</span> */}
            </div>
          </Col>
        </Row>
      </Container>

      {/* ratings modal */}
            <Modal show={showReviewModal} onHide={() => setShowReviewModal(false)} centered>
              <Modal.Header closeButton>
                <Modal.Title className="fw-bold text-muted">Users are saying...</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div style={{ maxHeight: "333px", overflowY: "auto" }}>
      
                  {reviewConsultant?.review?.length ? (
                    reviewConsultant.review.map((text, index) => (
                      <div key={index} className="mb-3">
                        <p className="mb-1 text-dark" style={{ fontSize: "0.95rem" }}>"{text}"</p>
                        <div className="text-warning" style={{ fontSize: "1rem" }}>
                          {renderStars(reviewConsultant.ratingArray?.[index])}
                        </div>
                        <hr />
                      </div>
                    ))
                  ) : (
                    <p className="text-muted">No reviews yet.</p>
                  )}
                </div>
              </Modal.Body>
            </Modal>
      

     
{/* Render Modal */}
      <PriestRegistrationModal isOpen={isModalOpen} onClose={closeModal} />
      {/* Footer */}
      <footer className="bg-dark text-white text-center p-3">
        &copy; 2025 Priests.Africa. All rights reserved.
      </footer>

      {/* Custom CSS */}
      <style>{`
        .hero-section {
          background: linear-gradient(90deg, rgba(0, 51, 0, 0.8), rgba(0, 100, 0, 0.9)),
                      url('https://source.unsplash.com/1200x600/?spiritual,africa');
          background-size: cover;
          background-position: center;
          padding: 100px 0;
        }

        .hero-image {
          width: 100%;
          height: auto;
          object-fit: cover;
          mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 25%, rgba(0, 0, 0, 0) 75%);
          -webkit-mask-image: radial-gradient(circle, rgba(0, 0, 0, 1) 25%, rgba(0, 0, 0, 0) 75%);
        }

      `}</style>

      
    </>
  );
};

export default LandingPage;
